export enum Locale {
  EN_US = "en-US",
  EN_CA = "en-CA",
  FR_CA = "fr-CA",
}
